/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component, EventEmitter, Input, Output} from '@angular/core';

/**
 * Expandable box component : a box with a visible header and a body hidden unless user hovers the header with their
 * mouse.
 */
@Component({
  selector: 'gp-ui-expandable-box, [gp-ui-expandable-box]',
  template: `
    <div class="box shadow fullWidth" (click-outside)="close()">
      <div class="box-header pointer" [style.padding]="padding" (click)="toggle()">
        <ng-content select=".gp-box-header"></ng-content>
      </div>
      <div class="box-body" [ngStyle]="{'visibility': bodyExpanded ? 'visible' : 'hidden'}">
        <ng-content select=".gp-box-body"></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./expandable-box.component.css']
})
export class ExpandableBoxComponent {

  @Output()
  public opened: EventEmitter<ExpandableBoxComponent> = new EventEmitter<ExpandableBoxComponent>();

  @Input() public padding: string = '1rem';

  public bodyExpanded: boolean = false;

  public toggle() {
    this.bodyExpanded ? this.close() : this.open();
  }

  public open() {
    this.bodyExpanded = true;
    this.opened.emit(this);
  }

  public close() {
    this.bodyExpanded = false;
  }
}
